import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits, parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";
import { contractIsSpecialCodeArg } from "../../utils/specialUser";

const usePurchaseUsdt = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.busd;

  const purchaseUsdt = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) return null;

      let nd;
      if (index) {
        const percent = parseFloat(amount) * insurancePer;
        const value = parseFloat(amount) + percent;
        const fixed = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(fixed.toString(), 6);
      } else {
        const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(fixed.toString(), 6);
      }

      let minValue = min * 0.99;
      minValue = Math.round(parseFloat(minValue).toFixed(6) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args: [
            UsdtAdress,
            postApiRes?.normalizationFactor,
            postApiRes?.price,
            nd,
            minValue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes.code,
            id,
            postApiRes.deadline,
            contractIsSpecialCodeArg(postApiRes),
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("Transaction confirmed:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("Transaction error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseUsdt };
};

export default usePurchaseUsdt;
